module.exports = __webpack_public_path__ + "static/media/tide_pool_badge.13eeadeb.svg";